/**
 * Literature link helpers for MindUP curriculum literary callouts
 * Generates live links to libraries and retailers for educators
 */

/** Build a WorldCat search URL (library catalog – find at local libraries) */
export function getWorldCatUrl(entry: string): string {
  const query = entry.replace(/\s*[–—-]\s*/, " ").trim();
  return `https://www.worldcat.org/search?q=${encodeURIComponent(query)}`;
}

/** Build an Open Library search URL (free online resource) */
export function getOpenLibraryUrl(entry: string): string {
  const query = entry.replace(/\s*[–—-]\s*/, " ").trim();
  return `https://openlibrary.org/search?q=${encodeURIComponent(query)}`;
}

/** Build an Amazon search URL (purchase) */
export function getAmazonUrl(entry: string): string {
  const query = entry.replace(/\s*[–—-]\s*/, " ").trim();
  return `https://www.amazon.com/s?k=${encodeURIComponent(query)}`;
}

export interface LiteratureLink {
  label: string;
  url: string;
}

/**
 * Get standard links for a literature list entry (e.g. "All Are Welcome – Alexandra Penfold")
 */
export function getLiteratureLinks(entry: string): LiteratureLink[] {
  return [
    { label: "Find in library", url: getWorldCatUrl(entry) },
    { label: "Open Library", url: getOpenLibraryUrl(entry) },
    { label: "Amazon", url: getAmazonUrl(entry) },
  ];
}
